import { useEffect, useState } from "react";
import "../css/customCard.css";
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton from 'react-loading-skeleton';
import { toIDR } from "../helpers";

export default function CustomCard({ product, detail, load, changePage }) {
  const [isLoading, setIsLoading] = useState(true);

  const switchPage = (page) => {
    if (changePage) changePage(page);
  }

  useEffect(() => {
    setIsLoading(load)
  }, [load]);

  return (
    <div className="grid-item" onClick={() => switchPage(`product/${product.id}`)}>
      <div className="grid-card-bg">
        <div style={{ backgroundImage: `url(${product.mainImg ? product.mainImg : product.imgUrl})` }}>
          {
            isLoading && <Skeleton style={{ position: "absolute", left: '0', top: '0', right: '0', bottom: '0' }} />
          }
        </div>
      </div>
      {
        detail &&
        <>
          {
            isLoading ?
              <div style={{ margin: '0 6px', display: 'grid', gridTemplateColumns: '70% 30%' }}>
                <div style={{ marginRight: '10px' }}>
                  <Skeleton />
                </div>
                <Skeleton />
              </div>
              :
              <div className="grid-content">
                <>
                  <div className="card-title">
                    {product.name}
                  </div>
                  <div>{toIDR(product.price)}</div>
                </>
              </div>
          }
        </>
      }
    </div >
  )
}